var _style, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKlarna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.klarna{fill:#FFA8CD;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "klarna",
    d: "M65.2,69.5H4.8c-2.4,0-4.3-1.9-4.3-4.3V4.8c0-2.4,1.9-4.3,4.3-4.3h60.4c2.4,0,4.3,1.9,4.3,4.3v60.4 C69.5,67.6,67.6,69.5,65.2,69.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M43.8,14.4c-3,0-6,0-8.9,0c-0.1,1.2-0.2,2.3-0.3,3.4c-0.5,3.4-1.6,6.6-3.5,9.5c-1.7,2.6-3.8,4.7-6.3,6.5 C23.9,34.5,23,35.3,22,36c0.1,0.1,0.1,0.1,0.1,0.2c4.5,6.2,8.9,12.4,13.4,18.7c0.2,0.2,0.4,0.3,0.7,0.3c3.1,0,6.2,0,9.3,0 c0.5,0,1,0,1.6,0c-4.3-5.9-8.5-11.8-12.7-17.6C40.6,31,43.7,23.3,43.8,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8,55.2c3,0,6,0,9.1,0c0-13.6,0-27.2,0-40.8c-3.1,0-6.1,0-9.1,0C11.8,28,11.8,41.6,11.8,55.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2,45.4c-2.8,0-5,2.3-5.1,5.1c0,2.8,2.2,5.2,5,5.2c2.8,0,5-2.3,5-5.1C58.2,47.7,56,45.4,53.2,45.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlarna);
export default __webpack_public_path__ + "static/media/klarna.d16ae716924d9c9af83b8fa293369c62.svg";
export { ForwardRef as ReactComponent };